<template>
  <div>
    <input
      type="email"
      :name="name"
      :class="(typeof error_validation !== 'undefined' && error_validation[name] != null) ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'"
      v-model="post"
      @input="send"
      @change="send"
      :required="required"
      :disabled="disabled"
    />
    <div
      class="invalid-feedback"
      v-if="typeof error_validation !== 'undefined' && error_validation[name] != null"
    >{{ error_validation[name] }}</div>
  </div>
</template>

<script>
export default {
  // props: ["name", "validation", "content", "error_validation", "disabled"],
  props:{
    validation: null,
    content: null,
    error_validation: null,
    name: {
      type: String,
      required: true,
    },
    disabled : {
      type: Boolean,
      // Object or array defaults must be returned from
      // a factory function
      default: function () {
        return false
      }
    }
  },
  data() {
    return {
      post: this.content
    };
  },
  computed: {
    required() {
      if (this.validation == "required") {
        return true;
      }

      return false;
    }
  },
  methods: {
    send() {
      this.$emit("post", {
        name: this.name,
        value: this.post
      });
    }
  }
};
</script>